import { Box, Button, Link, List, ListItem, ListItemText, TextField, Typography } from '@mui/material'
import React from 'react'

import { useAttachments, useCreateAttachment } from 'app/hooks/useAttachmentQueries'
import attachmentApi, { AttachmentOwnerType } from 'app/services/attachmentApi'

interface Props {
  ownerType: AttachmentOwnerType
  ownerId: number
}

const Attachments = ({ ownerType, ownerId }: Props) => {
  const [description, setDescription] = React.useState('')
  const [file, setFile] = React.useState<File | null>(null)
  const { data: attachments = [] } = useAttachments(ownerType, ownerId)
  const createAttachment = useCreateAttachment()

  const upload = async () => {
    if (!file) return

    await createAttachment.mutateAsync({ ownerType, ownerId, description, file })
    setDescription('')
    setFile(null)
  }

  return (
    <Box mt={2}>
      <Typography variant="h6">Attachments</Typography>
      <List dense>
        {attachments.map((attachment) => (
          <ListItem key={attachment.attachmentId} disableGutters>
            <ListItemText
              primary={
                <Link href={attachmentApi.getDownloadUrl(attachment.attachmentId)} target="_blank">
                  {attachment.fileName}
                </Link>
              }
              secondary={attachment.description}
            />
          </ListItem>
        ))}
        {!attachments.length && <ListItem disableGutters>No attachments.</ListItem>}
      </List>
      <TextField
        label="Description"
        value={description}
        onChange={(event) => setDescription(event.target.value)}
        fullWidth
        margin="dense"
      />
      <Button component="label" variant="outlined" size="small">
        Select file
        <input hidden type="file" onChange={(event) => setFile(event.target.files?.[0] || null)} />
      </Button>
      {file && (
        <Button
          sx={{ ml: 1 }}
          size="small"
          variant="contained"
          disabled={createAttachment.isPending}
          onClick={upload}
        >
          Upload {file.name}
        </Button>
      )}
    </Box>
  )
}

export default Attachments
